import { StyleSheet } from 'react-native';
import { widthPercentageToDP as wp } from 'react-native-responsive-screen';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
  },
  containerLandscape: {
    flex: 1,
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
  },
  iconLarge: {
    marginRight: '4%',
    alignSelf: 'flex-end',
    justifyContent: 'flex-end',
  },
  iconSmall: {
    marginRight: '5%',
    alignSelf: 'flex-end',
    justifyContent: 'center',
  },
  sectionContainer: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
  },
  title: {
    marginBottom: 50,
    alignSelf: 'center',
    width: 100,
    height: 150,
    resizeMode: 'stretch',
  },
  titleLandscape: {
    marginBottom: 35,
    alignSelf: 'center',
    width: 75,
    height: 130,
    resizeMode: 'stretch',
    marginRight: 45,
  },
  btnContainerLarge: {
    width: 300,
    marginTop: '5%',
    alignSelf: 'center',
  },
  btnContainerSmall: {
    width: wp('90%'),
    marginTop: '1%',
    alignSelf: 'center',
  },
  btnStyle: {
    height: 50,
    backgroundColor: '#001C47',
    borderRadius: 5,
  },
  btnTitle: {
    color: '#FFFFFF',
    fontSize: 22,
    fontWeight: '700',
    lineHeight: 24,
  },
});
